export const TRACKING_URL = 'https://track.instabox.io'
export const WWW_URL = 'https://instabox.io'
